query (
  $key: String!
  $contentType: String!
) {
  getSignedUploadUrl(
    key: $key
    contentType: $contentType
  )
}
